import { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

const ArticleListing = dynamic(() => import('../../components/ArticleListing'));

export async function getServerSideProps({ query }) {
  const id = query.id;
  const page = query.page || 1;
  const pages = await fetch(`${process.env.NEXT_PUBLIC_API_PROTO}://${process.env.NEXT_PUBLIC_API_HOST}:${process.env.NEXT_PUBLIC_API_PORT}/api/${process.env.NEXT_PUBLIC_API_VERSION}/search/${id}?page=${page}`);
  const data = await pages.json();
  return {
    props: {
      pages: data
    },
  };
}

function SearchPage({ pages: initialPages }) {
  const router = useRouter();
  const observer = useRef(null);
  const [pageData, setPageData] = useState(initialPages);
  const [element, setElement] = useState(null);
  const [isRendered, setIsRendered] = useState(false);

  async function getNextPage(query) {
    setIsRendered(false);
    const id = query.id;
    const page = query.page || 1;
    const request = await fetch(`//${process.env.NEXT_PUBLIC_API_HOST_EXTERNAL}/api/${process.env.NEXT_PUBLIC_API_VERSION}/search/${id}?page=${page}`);
    const newPage = await request.json();

    if (newPage.list) {
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page: page }
      }, undefined, { shallow: true });

      const combinedItems = [...pageData.list, ...newPage.list];
      setPageData({ ...newPage, list: combinedItems });
    }
    
    setTimeout(() => {
      setIsRendered(true);
    }, 1000);
  }

  useEffect(() => {
    setIsRendered(true);
  }, []);

  useEffect(() => {
    if (isRendered) {
      observer.current = new IntersectionObserver(
        entries => {
          const firstEntry = entries[0];
          if (firstEntry.isIntersecting && pageData.pagination && isRendered) {
            const nextPage = pageData.pagination.current_page + 1;
            getNextPage({
              id: router.query.id,
              page: nextPage
            });
          }
        },
        { threshold: 1.0 }
      );

      if (element) {
        observer.current.observe(element);
      }
    }

    return () => {
      if (observer.current && element) {
        observer.current.unobserve(element);
      }
    };
  }, [element, isRendered, pageData.pagination, router]);

  useEffect(() => {
    // Update pageData when initialPages changes
    setPageData(initialPages);
  }, [initialPages]);

  return (
    <div>
      <ArticleListing info={pageData} list={pageData.list} />
      <div ref={setElement} />
    </div>
  );
}

export default SearchPage;
